/** @format */

import PlayIcon from '@/assets/icons/card-room-play-icon.svg';
import { useDelayedUnmount } from '@/ducks/general/hooks/useDelayedUnmount';
import { TTranslation, useAppTranslation } from '@/i18n/declarations';
import React, { Dispatch, FunctionComponent as FC, SetStateAction } from 'react';
import { Icon } from '../../Icon';
import { ButtonPlayVR, Desktop, Frame, ModalVRContainer, WrapperVR } from './index.style';
import { SlideBottomSheet } from './SlideBottomSheet';

export const VRSlide: FC<VRSlideProps> = ({ url, backgroundPicture, vrState }) => {
  const { t } = useAppTranslation();
  const [isPlaying, setIsPlaying] = vrState;
  const shouldRenderPanel = useDelayedUnmount(isPlaying, 400);

  return (
    <ModalVRContainer>
      {!isPlaying && (
        <WrapperVR>
          <img src={backgroundPicture} alt="background" />
          <ButtonPlayVR onClick={() => setIsPlaying(true)}>
            {t('plp.card.modal.tabs.vr' as TTranslation)}
            <Icon icon={PlayIcon} width={24} height={24} />
          </ButtonPlayVR>
        </WrapperVR>
      )}
      <Desktop>{isPlaying && <Frame src={`${url}&play=1`} frameBorder={0} />}</Desktop>
      {shouldRenderPanel && (
        <SlideBottomSheet
          label={t('plp.card.modal.tabs.vr' as TTranslation)}
          onClose={() => setIsPlaying(false)}
          isOpen={isPlaying}
        >
          <Frame src={`${url}&play=1`} frameBorder={0} />
        </SlideBottomSheet>
      )}
    </ModalVRContainer>
  );
};

interface VRSlideProps {
  url: string;
  backgroundPicture: string;
  vrState: [boolean, Dispatch<SetStateAction<boolean>>];
}
